module.exports = "pegasus/assets/tech/medium/7.jpg";